import { createSelector } from 'reselect'

import { RootState } from '../../core/store/root.reducer'

export const selectFeatureFlags = (state: RootState) => state.featureFlags

export const selectFeatureFlag = (featureFlagName: string) =>
  createSelector(selectFeatureFlags, (featureFlags) => !!featureFlags?.[featureFlagName])
